import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { formatMoney } from 'helpers/format';
import './Money.scss';
/**
 * @component Money
 * @since 1.0.0
 */
export function Money(props) {
    let { style, showCurrency, value } = Object.assign({ style: 'normal', value: 0, showCurrency: false }, props);
    if (value == null) {
        value = 0;
    }
    const className = classNames('money', 'money--' + style, props.className);
    return React.createElement("span", { className: className }, toMoney(value, props.currency));
}
/**
 * @var toMoney
 * @since 1.0.0
 */
export function toMoney(value, currency) {
    return formatMoney(value, { currency });
}
